import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Flame } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-slate-900">
      <div className="hidden lg:flex flex-1 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1599974579688-8dbdd335c77f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
          alt="Itacate Taquería"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/60 to-slate-900" />
        <div className="relative z-10 flex flex-col justify-end p-12">
          <h1 className="font-heading text-4xl font-bold text-white tracking-tight">ITACATE FINANCE</h1>
          <p className="text-slate-300 mt-2 max-w-md text-sm leading-relaxed">
            Gestión financiera centralizada para ITACATE Taquería Mexicana. Ventas, facturas, proveedores y tesorería en una sola fuente de verdad.
          </p>
        </div>
      </div>
      <div className="w-full lg:w-[480px] flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-[#D9381E] flex items-center justify-center">
              <Flame className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg tracking-tight">ITACATE FINANCE</div>
              <div className="text-xs text-slate-500">Acceso interno</div>
            </div>
          </div>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email-input" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Contraseña</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
          <Button data-testid="login-submit-button" type="submit" disabled={loading}
            className="w-full bg-[#D9381E] hover:bg-[#B91C1C] text-white h-10">
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
